import { can } from "../../../hooks/useEffectivePermissions";

export function hasGlobalTeamTasksManage(scopes) {
  return can(scopes, "team_tasks", "manage");
}

export function hasTeamTasksView(scopes) {
  return (
    can(scopes, "team_tasks", "view") ||
    can(scopes, "team_tasks", "manage") ||
    can(scopes, "team_chat", "view")
  );
}

/** Painel dedicado do portal do cliente (id_cliente). */
export function isClientBoard(board) {
  return Boolean(board && board.clientId != null && Number(board.clientId) > 0);
}

/**
 * Painel “de workspace” (lista Seus painéis): sem canal, solicitação ou cliente.
 * Painéis de cliente NÃO entram aqui — senão exigem role de membro inexistente.
 */
export function isWorkspaceBoard(board) {
  return Boolean(board && !board.spaceId && !board.leadId && !isClientBoard(board));
}

export function canManageTeamBoard(scopes, board) {
  if (isClientBoard(board)) {
    return hasGlobalTeamTasksManage(scopes);
  }
  if (isWorkspaceBoard(board)) {
    const role = board?.currentUserRole;
    return role === "owner" || role === "admin";
  }
  if (hasGlobalTeamTasksManage(scopes)) return true;
  const role = board?.currentUserRole;
  return role === "owner" || role === "admin";
}

export function canCreateTeamTask(scopes, board) {
  if (isClientBoard(board)) {
    return hasTeamTasksView(scopes);
  }
  if (isWorkspaceBoard(board)) {
    const role = board?.currentUserRole;
    return role === "owner" || role === "admin" || role === "member" || role === "viewer";
  }
  return canManageTeamBoard(scopes, board);
}

export function canExecuteTeamTask(scopes, board, card, currentUserId) {
  if (isClientBoard(board)) {
    // Equipe com acesso a tarefas pode atribuir, mover e tratar demandas do portal.
    return hasTeamTasksView(scopes);
  }
  if (isWorkspaceBoard(board)) {
    const role = board?.currentUserRole;
    return role === "owner" || role === "admin" || role === "member" || role === "viewer";
  }
  if (canManageTeamBoard(scopes, board)) return true;
  const uid = Number(currentUserId);
  if (!uid) return false;
  const assignees = (card?.assignees || []).map(Number);
  if (assignees.includes(uid)) return true;
  return false;
}

export function canManageBoardMembers(scopes, board) {
  if (isClientBoard(board)) return false;
  return canManageTeamBoard(scopes, board);
}
